<template>
    <div class="card widget widget-products" v-if="(latest_products.length > 0 || related_products.length > 0)">
        <div class="widget__header">
            <h4>{{cardTitle}}</h4>
        </div>

        <div class="widget-products__list" v-if="related_products.length == 0">
            <latest-product-item v-for="(product, indx) in latest_products"
                :key="product.ID"
                :index="indx"
                :productDetails="product"
                :productRelated="false">
            </latest-product-item>
        </div>

        <div class="widget-products__list" v-if="related_products.length > 0">
            <latest-product-item v-for="(product, indx) in related_products"
                :key="product.ID"
                :index="indx"
                :productDetails="product"
                :productRelated="true">
            </latest-product-item>
        </div>
    </div>
</template>

<script>

import LatestProductItem from './LatestProductItem.vue';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import Cloudinary from '../../../utilities/cloudinary';
import * as GCONST from '../../../constants.js';
import axiosvl from "../../../axios/axios-vl.js";
import {scale} from "@cloudinary/base/actions/resize";

export default {
    components: { LatestProductItem },

    data() {
        return {
            latest_products : [],
            related_products: [],
            cardTitle: 'Featured Products',
        };
    },

    computed: {
        // latest_products() {
        //     return this.$store.getters['product/latest'];
        // }
    },

    methods: {

        // fetch the latest products from cloudinary
        fetchLatestProducts() {
            // get cloudinary image
            const clApi = new CloudinaryApi;

            // large image
            clApi.vlLatestProducts(GCONST.CL_METARTYPE_LATEST).then(images => {
                if(images){
                    // loop through the fetched images
                    images.forEach(img => {
                        if (img.metadata.itemsku &&  img.metadata.mfgcode){
                            const clImage = Cloudinary.image(img.publicId);
                            clImage.resize(scale().width(GCONST.Latest_Products));
                            // get the product details from the web service
                            this.getProductDetails(img.metadata.itemsku, img.metadata.mfgcode, clImage.toURL());
                        }
                    });  // end images loop
                }
            });
        },

        // get product details from the web service
        getProductDetails(itemsku, manufacturer, image){
            // console.log(image);
            axiosvl.post(this.$store.getters['api/product_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },   
                    "fields": {
                        "EHCUST": { "value": this.$store.getters['customer'] },
                        "EIMFGC": { "value": manufacturer },
                        "EIITMC": { "value": itemsku },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {

                    const linetotal = 1 * fields.EIEXCP.value;
                    const defaultLoc = this.$store.getters.getCustomerDetails;
                    const clearProductDesc = encodeURIComponent(fields.IMDESC.value);

                    this.prod = {
                        ID: fields.IMITMC.value,
                        IMITMC: fields.IMITMC.value,
                        item: fields.IMITMC.value,
                        desc: fields.IMDESC.value,
                        manufacturer: fields.IMMFGC.value,
                        image: image,
                        quantity: this.requestedQuantity,
                        corecharge: fields.EICORP.value,
                        yourprice: fields.EIEXCP.value,
                        listprice: fields.EILSTP.value,
                        shipping: 0,
                        linetotal: linetotal,
                        stockquantity: fields.QTYAVL.value,

                        mfgSeo        : fields.MCNAME.value.replace(/ /g, "-"),
                        itemSeo       : clearProductDesc.replace(/ /g, "-"),

                        locationid: fields.CMDLOC.value,
                        locationname: defaultLoc.defaultlocationname,
                        locationcity: defaultLoc.defaultlocationcity,
                        locationstate: defaultLoc.defaultlocationstate,
                    };

                    this.latest_products.push(this.prod);
                }else{
                    this.isloading = false;
                }
            })
            .catch((error) => {
                console.log("error - " + error);
            });
        },

        fetchRelatedProducts() {
            const manufacturer  = this.$route.params.manufacturer;
            const itemsku  = this.$route.params.partnumber;

            // console.log(image);
            axiosvl.post(this.$store.getters['api/related_parts_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },   
                    "fields": {
                        "EHCUST": { "value": this.$store.getters['customer'] },
                        "EIMFGC": { "value": manufacturer },
                        "EIITMC": { "value": itemsku },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const RPARTS = response.data.webroutine.lists.RPARTS.entries;
                const PARTLOC = response.data.webroutine.lists.PARTLOC.entries;
                const defaultLoc = this.$store.getters.getCustomerDetails;
                const wd_mdfgs = this.$store.getters.wd_mfgs;

                if (fields.RESULTCOD.value === 'OK') {

                    if(RPARTS.length > 0){
                        this.cardTitle = 'Related Products';
                    }else{
                        this.cardTitle = 'Featured Products';
                        this.fetchLatestProducts();
                    }

                    RPARTS.forEach(obj => {
                        const clearProductDesc = encodeURIComponent(obj.IMDESC);

                        this.prod = {
                            ID: obj.DMITMC,
                            IMITMC: obj.DMITMC,
                            item: obj.DMITMC,
                            desc: obj.IMDESC,
                            manufacturer: obj.DMMFGC,
                            image: GCONST.THUMB_IMAGE_PLACEHOLDER,
                            quantity: 0,
                            corecharge: obj.CORP,
                            yourprice: obj.PRC,
                            listprice: obj.EILSTP,
                            shipping: 0,
                            linetotal: 0,
                            stockquantity: obj.QTYAVL,

                            mfgSeo        : wd_mdfgs.find(w => w.MFG_CODE == obj.IUUMFG).SEO,
                            itemSeo       : clearProductDesc.replace(/ /g, "-"),

                            locationid: 0,
                            locationname: defaultLoc.defaultlocationname,
                            locationcity: defaultLoc.defaultlocationcity,
                            locationstate: defaultLoc.defaultlocationstate,
                        };

                        if(PARTLOC.length > 0){
                            this.prod.locationid = PARTLOC[0].ILLOC;
                            this.prod.locationname = PARTLOC[0].LCNAME;
                            this.prod.locationcity = PARTLOC[0].LCLOCC;
                            this.prod.locationstate = PARTLOC[0].LCTAXC;
                        }

                        this.related_products.push(this.prod);
                    });
                    
                }else{
                    this.isloading = false;
                }
            })
            .catch((error) => {
                console.log("error - " + error);
            });
        }
    },
    created() {
        this.fetchRelatedProducts();
    }
    
}
</script>